import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPublicCourses, StateStatus } from '@guryou/redux';

const useCourses = (stateSelector, { providerId, fetchFromRemote = true }) => {
  const dispatch = useDispatch();
  const { data, status, version, entity } = useSelector(stateSelector);

  useEffect(() => {
    if (fetchFromRemote && status === StateStatus.NOT_INITIALIZED) {
      dispatch(getPublicCourses(providerId));
    }
  }, [dispatch, fetchFromRemote, providerId, status]);

  return { data: data || [], status, version, entity };
};

export default useCourses;
